export const ModalMessages = {
  title: 'Comentários - Pedido {orderID}'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/ModalMessages.js